module.exports = __webpack_public_path__ + "static/media/team_1.4cbca1b2.png";